import React, { ReactElement, useState } from 'react';
import { createGlobalStyle } from 'styled-components';

import { Typography, Flex, Box, Row, Col } from 'components';

import Term from './Term';

import {
  Wrapper,
  ContentWrapper,
  //   Header,
  //   HeaderContent,
  // DownloadIcon,
  // DocumentTypography,
  Square,
  LinkButton,
  // LinkButtonDisabled,
  TermsLink,
  AlertIcon,
  //   HeaderWrapper,
  // FlexDownload,
  // MobileBreak,
  Header,
  Overlay,
  SquareLines,
  Plus,
} from './styles';

const GlobalStyle = createGlobalStyle`
    body {
        background: ${({ theme }) => theme.colors.black80};
    }
`;

const Imersao = (): ReactElement => {
  const [showTerm, setShowTerm] = useState(false);

  const hideTerm = () => {
    setShowTerm(false);
  };

  return (
    <>
      {showTerm && <Term hideTerm={hideTerm} />}

      <Wrapper>
        <Header>
          <Overlay pt={{ m: 40, t: 100, d: 150 }} pr={{ m: 40, t: 60, d: 100 }} pb={{ m: 40, t: 60, d: 100 }} pl={{ m: 60, t: 120, d: 230 }}>
            <Flex zIndex={15} flexDirection="column">
              <Typography type="type6" fontWeight="bold" color="white" upper style={{ position: 'relative' }}>
                <SquareLines />
                Formação
              </Typography>

              <Typography type="type10" fontWeight="bold" color="white" mt={{ m: 1, t: '10px' }}>
                Mercado de Opções
              </Typography>

              <Typography color="white" type="type2" mt={{ m: 3, t: 20, d: 40 }} lineHeight={1.3}>
                Este é o curso mais completo sobre o mercado de opções já feito na história do mercado financeiro brasileiro.
                <br />
                <br />
                Ele é direcionado a aqueles que desejam utilizar opções para os seus investimentos pessoais e, também, a aqueles que atuam ou
                pretendem atuar como profissionais de renda variável em um escritório de AAI ou em uma corretora.
                <br />
                <br />
                Neste curso, os alunos aprenderão fundamentos do mercado de opções, estratégias, precificação e vários outros assuntos.
                <br />
                <br />
                O curso conta com diversos e-books, centenas de exercícios, cases, videoaulas e lives.
                <br />
                <br />O início do curso está previsto para fevereiro de 2022.
                <br />
                <br />
                <strong>Oferta e condições exclusivas para alunos da mentoria.</strong>
              </Typography>
            </Flex>
          </Overlay>
        </Header>

        <Flex bg="dark_350" py={{ m: 40, d: 60 }} px={{ m: 20 }}>
          <ContentWrapper>
            <Row>
              <Col width={{ m: 1, t: 1 / 2 }}>
                <Flex flexDirection="column" pr={4} justifyContent="flex-start">
                  <Typography upper color="white" fontWeight="bold">
                    Sobre a Formação:
                  </Typography>

                  <Typography color="white50" mt={3} lineHeight={1.5}>
                    <ul style={{ margin: 0, padding: 0, paddingLeft: 15 }}>
                      <li>8 semanas;</li>
                      <li>14 módulos;</li>
                      <li>Videoaulas disponibilizadas semanalmente;</li>
                      <li>Lives;</li>
                      <li>Ebooks;</li>
                      <li>Centenas de exercícios;</li>
                      <li>Cases comentados.</li>
                    </ul>
                  </Typography>

                  <Typography type="type2" color="white50" mt={4} lineHeight={1.3}>
                    Obs: As lives serão às terças-feiras, 12h. Todas elas serão gravadas e disponibilizadas em até 3 dias.
                  </Typography>
                </Flex>
              </Col>

              <Col width={{ m: 1, t: 1 / 2 }}>
                <Flex flexDirection="column" justifyContent="flex-start" mt={{ m: 50, d: 0 }}>
                  <Typography upper color="white" fontWeight="bold">
                    Sobre o Treinamento presencial:
                  </Typography>

                  <Typography color="white50" mt={3} lineHeight={1.5}>
                    <ul style={{ margin: 0, padding: 0, paddingLeft: 15 }}>
                      <li>Aplicação das estratégias aprendidas na Formação;</li>
                      <li>Discussão de casos que aconteceram no mercado, dias antes do encontro;</li>
                      <li>Debates em grupo;</li>
                      <li>Bastidores do mercado de renda variável.</li>
                    </ul>
                  </Typography>
                </Flex>
              </Col>
            </Row>
          </ContentWrapper>
        </Flex>

        <ContentWrapper>
          <Flex mt={{ m: 30, d: 120 }} justifyContent="space-between">
            <Flex p={{ m: 20, d: 0 }} flexDirection="column">
              <Typography type="type7" color="white" fontWeight="bold" upper>
                Encontro
              </Typography>

              <Typography type="type10" color="white" fontWeight="bold" upper>
                Presencial
              </Typography>
            </Flex>
            {/*
            <Flex px={{ m: '10px', d: 0 }} alignItems="center">
              <a href="/downloads/imersao/imersao.pdf" target="_blank">
                <DownloadIcon />
              </a>

              <FlexDownload ml="5px" alignItems="center">
                <DocumentTypography href="/downloads/imersao/imersao.pdf" target="_blank">
                  Baixe o material
                  <MobileBreak /> com todos os detalhes
                </DocumentTypography>
              </FlexDownload>
            </Flex> */}
          </Flex>

          <Box mt={{ m: '10px', d: 60 }}>
            <img src="/images/opcoes/body.jpg" alt="" />
          </Box>

          <Flex mt={{ m: 30, d: 120 }} px={{ m: 20, d: 0 }} pt={{ m: 20, d: 0 }} flexDirection="column">
            <Typography type="type7" color="white" fontWeight="bold" upper>
              Forma de
            </Typography>

            <Typography type="type10" color="white" fontWeight="bold" upper>
              Pagamento
            </Typography>
          </Flex>

          <Flex mx={{ d: 0 }} mt={{ m: 20, d: 30 }}>
            <Row gutter={30}>
              <Col width={{ m: 1, t: 1 / 2, d: 1 / 2 }}>
                <Flex mx={{ m: 20, d: 0 }} flexDirection="column" px={{ m: 30, d: 50 }} pb={{ m: 30, d: 40 }} borderRadius={4} bg="dark_350">
                  <Flex flexDirection="column">
                    <Square />

                    <Typography type="type2" color="white" fontWeight="regular" upper mt={2}>
                      Formação
                    </Typography>

                    <Typography type="type5" color="white" fontWeight="bold" upper mt={1} lineHeight={1.2}>
                      Mercado de Opções
                    </Typography>

                    <Typography type="type0" color="white25" mt={1}>
                      Curso on-line
                    </Typography>
                  </Flex>

                  <Flex flexDirection="column" flexGrow={0} mt={{ m: 3, d: 6 }}>
                    <Typography type="type5" color="white" fontWeight="bold" mt={1}>
                      12x de R$ 408,53
                    </Typography>

                    <Typography type="type1" color="white" mt={1} mb={3}>
                      Ou à vista R$ 4.000,00 sem juros
                    </Typography>

                    <Flex flexDirection="column">
                      <LinkButton target="_blank" href="https://api.melver.com.br/api/v1/School/PaymentLinks/melver/opcoes">
                        Comprar
                      </LinkButton>
                      {/* <LinkButtonDisabled>Inscrições Encerradas</LinkButtonDisabled> */}

                      <Typography lineHeight="1.3" type="type0" color="white25" mt={3}>
                        Ao clicar em comprar, declaro que aceito os <TermsLink onClick={() => setShowTerm(true)}>termos de uso</TermsLink> do produto.
                      </Typography>
                    </Flex>
                  </Flex>
                </Flex>
              </Col>

              <Col width={{ m: 1, t: 1 / 2, d: 1 / 2 }}>
                <Flex
                  mt={{ m: 5, t: 0, d: 0 }}
                  mx={{ m: 20, d: 0 }}
                  flexDirection="column"
                  px={{ m: 30, d: 50 }}
                  pb={{ m: 30, d: 40 }}
                  borderRadius={4}
                  bg="dark_350"
                >
                  <Flex flexDirection="column">
                    <Square />

                    <Typography type="type2" color="white" fontWeight="regular" upper mt={2}>
                      Formação
                    </Typography>

                    <Typography type="type5" color="white" fontWeight="bold" upper mt={1} lineHeight={1.2}>
                      Mercado de Opções <Plus>+</Plus> Treinamento Presencial
                    </Typography>

                    <Typography type="type0" color="white25" mt={1}>
                      Curso on-line + evento presencial
                    </Typography>
                  </Flex>

                  <Flex flexDirection="column" flexGrow={0} mt={{ m: 3, d: 6 }}>
                    <Typography type="type5" color="white" fontWeight="bold" mt={1}>
                      12x de R$ 653,65
                    </Typography>

                    <Typography type="type1" color="white" mt={1} mb={3}>
                      Ou à vista R$ 6.400,00 sem juros
                    </Typography>

                    <Flex flexDirection="column">
                      <LinkButton target="_blank" href="https://api.melver.com.br/api/v1/School/PaymentLinks/melver/opcoes_presencial">
                        Comprar
                      </LinkButton>
                      {/* <LinkButtonDisabled>Inscrições Encerradas</LinkButtonDisabled> */}

                      <Typography lineHeight="1.3" type="type0" color="white25" mt={3}>
                        Ao clicar em comprar, declaro que aceito os <TermsLink onClick={() => setShowTerm(true)}>termos de uso</TermsLink> do produto.
                      </Typography>
                    </Flex>
                  </Flex>
                </Flex>
              </Col>
            </Row>
          </Flex>
          {/* <Flex
            mx={{ m: 20, d: 0 }}
            flexDirection={{ m: 'column', d: 'row' }}
            flexWrap={{ d: 'nowrap' }}
            px={25}
            mt={4}
            borderRadius={4}
            bg="#2A2C2B"
            justifyContent={{ m: 'flex-start', d: 'space-around' }}
          >
            <Flex maxWidth={{ m: 'auto', d: 200 }} flexGrow={0} flexWrap="nowrap">
              <Square />

              <Flex
                pt={{ m: 50, d: 46 }}
                pb={{ m: 0, d: 40 }}
                pl={{ m: 25, d: 35 }}
                flexDirection="column"
              >
                <Typography type="type5" color="white" fontWeight="bold" upper>
                  Pacote FUll
                </Typography>

                <Typography lineHeight="1.4" type="type0" color="white25" mt={2}>
                  Participação individual na imersão e no evento presencial.
                </Typography>
              </Flex>
            </Flex>

            <Flex
              flexGrow={1}
              pl={{ m: 28, d: 0 }}
              justifyContent={{ m: 'flex-start', d: 'center' }}
            >
              <Flex flexGrow={0} flexDirection="column" pt={{ m: 30, d: 46 }}>
                <Typography type="type1" color="white25" upper>
                  Valor da imersão:
                </Typography>

                <Typography type="type5" color="white" fontWeight="bold" mt={1}>
                  12x de R$ 2.553,33
                </Typography>

                <Typography type="type1" color="white" mt={1}>
                  Ou à vista R$ 25.000,00 sem juros
                </Typography>
              </Flex>
            </Flex>

            <Flex
              pt={{ m: 30, d: 46 }}
              pb={{ m: 30, d: 0 }}
              ml={25}
              flexShrink={0}
              flexGrow={0}
              maxWidth={{ m: 220, d: 250 }}
              flexDirection="column"
            >
              <LinkButton href="https://checkout.premepay.com/aGLU9R">Comprar</LinkButton>

              <Typography lineHeight="1.3" type="type0" color="white25" mt={3}>
                Ao clicar em comprar, declaro que aceito os{' '}
                <TermsLink onClick={() => setShowTerm(true)}>termos de uso</TermsLink> do produto.
              </Typography>
            </Flex>
          </Flex> */}

          <Flex mt={{ m: 30, d: 60 }} mx={{ m: 20, d: 0 }} border="1px solid #424543" borderRadius="4px" alignItems="center" flexWrap="nowrap">
            <Flex flexGrow={0} m={3}>
              <AlertIcon />
            </Flex>

            <Typography lineHeight="1.4" type="type0" color="#9F9F9F">
              No valor do treinamento presencial não estão incluídas despesas com transporte, hospedagem e alimentação.
            </Typography>
          </Flex>

          <Box flexGrow={1} textAlign="center" pt={{ m: 40, d: 100 }} pb="20px">
            <Typography lineHeight="1.4" type="type0" color="#9F9F9F">
              © Todos os direitos reservados a MELVER LTDA.
            </Typography>
          </Box>
        </ContentWrapper>
      </Wrapper>
      <GlobalStyle />
    </>
  );
};
export default Imersao;
